import isEqual from 'lodash.isequal';

export default {
  name: 'fee-schedule-mixin',
  props: {
    isFeeSchedulesFromApi: {
      type: Boolean,
      default: true,
    },
    feeSchedules: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    async getFeeScheduleList() {
      if (this.isFeeSchedulesFromApi) {
        try {
          return await this.getFeeScheduleListFromApi();
        } catch {
          return [];
        }
      } else {
        return this.feeSchedules;
      }
    },
    emitUpdatedFeeSchedulesData() {
      let emitEvent;
      if (this.isFeeSchedulesFromApi) {
        emitEvent = true;
      } else {
        emitEvent = !isEqual(this.feeScheduleList, this.feeSchedules);
      }
      if (!emitEvent) {
        return;
      }
      this.$emit('fee-schedules-updated', this.feeScheduleList);
    },
  },
};
